import { NavigationItem } from "@/config/navigation/types";

export function filterHiddenApps(apps: NavigationItem[], hiddenIds: string[]): NavigationItem[] {
  const hidden = new Set(hiddenIds);
  return apps.filter((app) => !hidden.has(app.id));
}
